import Vue from "vue";
import Vuex from "vuex";
import StoreChapterSeeIt from "./storeChapterSeeIt";
import storeChapterBuy from "./storeChapterBuy";
import storeChapterShop from "./storeChapterShop";
import storeChapterOffer from "./storeChapterOffer";
import storeChapterStore from "./storeChapterStore";
import storeChapterShare from "./storeChapterShare";
import storeChapterLearn from "./storeChapterLearn";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    topBarIsShown: false,
    isHelpShown: false,
    currentScreen: null,
    showDismissibleAlert: false,
    chapters: [
      {
        showBulb: false,
        number: "01",
        chapterId: "see-it",
        name: "SEE  IT",
        screenImagesFolderName: "seeit",
        storyboardScreens: StoreChapterSeeIt.storyboardScreens
      },
      {
        showBulb: false,
        number: "02",
        name: "OFFER",
        chapterId: "offer",
        screenImagesFolderName: "offer",
        storyboardScreens: storeChapterOffer.storyboardScreens
      },
      {
        showBulb: false,
        number: "03",
        name: "STORE",
        chapterId: "store",
        screenImagesFolderName: "store",
        storyboardScreens: storeChapterStore.storyboardScreens
      },

      {
        showBulb: false,
        number: "04",
        name: "SHOP",
        chapterId: "shop",
        screenImagesFolderName: "shop",
        storyboardScreens: storeChapterShop.storyboardScreens
      },
      {
        showBulb: false,
        number: "05",
        name: "BUY",
        chapterId: "buy",
        screenImagesFolderName: "buy",
        storyboardScreens: storeChapterBuy.storyboardScreens
      },
      {
        showBulb: false,
        number: "06",
        name: "SHARE",
        chapterId: "share",
        screenImagesFolderName: "share",
        storyboardScreens: storeChapterShare.storyboardScreens
      },
      {
        showBulb: true,
        name: "LEARN  MORE",
        chapterId: "learn",
        screenImagesFolderName: "learn",
        storyboardScreens: storeChapterLearn.storyboardScreens
      }
    ]
  },
  mutations: {
    SET_CURRENT_SCREEN: (state, screenId) => {
      for (let chapter of state.chapters) {
        let currentScreen = chapter.storyboardScreens.find(
          a => a.screenId == screenId
        );
        //evcerything here
        if (currentScreen != null) {
          return (state.currentScreen = currentScreen);
        }
      }
    },
    TOP_BAR_IS_SHOWN: state => (state.topBarIsShown = true),
    IS_HELP_SHOWN: state => (state.isHelpShown = true),
    IS_HELP_HIDEN: state => (state.isHelpShown = false),
    TOP_BAR_IS_HIDEN: state => (state.topBarIsShown = false),
    SHOW_ALLERT: state => (state.showDismissibleAlert = true),
    HIDE_ALLERT: state => (state.showDismissibleAlert = false)
  },
  actions: {},
  getters: {
    topBarIsShown: state => state.topBarIsShown,
    showDismissibleAlert: state => state.showDismissibleAlert,
    chapters: state => state.chapters,
    isHelpShown: state => state.isHelpShown,
    currentScreen: state => state.currentScreen,
    infoBoxPositin: state => state.infoBoxPositin
  }
});
